<template>
  <home-page />
</template>
